module.exports = ".logs{\r\n    width : 250px;\r\n}\r\n\r\n.white{\r\n    color: white;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/basic-assigment-3/basic-assigment-3.component.css
// module id = ./src/app/components/basic-assigment-3/basic-assigment-3.component.css
// module chunks = main